<template>
    <div class="header">
        <!-- <img src="" alt="新时代家谱" /> -->
        <div v-if="flag == 'pc'" class="header-pc">
            <span> <img src="@/assets/img/logo1.png" alt="" />&nbsp;&nbsp;新时代家谱</span>
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                <el-menu-item index="2">
                    <router-link to="/family">家谱定位表</router-link>
                </el-menu-item>
                <el-menu-item index="1">
                    <router-link to="/lineageChart">家族世系图</router-link>
                </el-menu-item>
                <el-menu-item index="9">
                    <router-link to="/scorebook">谱书</router-link>
                </el-menu-item>
                <el-menu-item index="3">
                    <router-link to="/distributed">家族分布图表</router-link>
                </el-menu-item>
                <el-menu-item index="4">
                    <router-link to="/migrate">家族迁徒图表</router-link>
                </el-menu-item>
                <el-menu-item index="10">
                    <router-link to="/news">家族动态</router-link>
                </el-menu-item>
                <el-menu-item index="5">
                    <router-link to="/fivefu">九族五服图</router-link>
                </el-menu-item>
                <el-menu-item index="6">
                    <router-link to="/lookfor">一键寻祖</router-link>
                </el-menu-item>
                <el-menu-item index="7">
                    <router-link to="/cancestor">查找共祖</router-link>
                </el-menu-item>
                <el-menu-item index="8">
                    <router-link to="/statistics">查询汇总</router-link>
                </el-menu-item>
            </el-menu>
            <el-dropdown class="fr" @command="handleCommand">
                <span class="el-dropdown-link"> 用户名<i class="el-icon-arrow-down el-icon--right"></i> </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit">修改资料</el-dropdown-item>
                    <el-dropdown-item command="logout">退出</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div v-if="flag == 'app'" class="header-app">
            <nav class="navbar navbar-expand-md bg-dark navbar-dark">
                <a class="navbar-brand" href="#/mobileguide"><img src="@/assets/img/logo1.png" alt="" />&nbsp;&nbsp;新时代家谱</a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
                    <!-- <span class="navbar-toggler-icon"></span> -->
                    <!-- <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation"> -->
                       <p style="color:#fff;font-size: 14px;margin-bottom: 4px;">选看</p>
                        <i><img src="@/assets/img/czlo.jpg" alt="" style="width:30px;border-radius:4px"/></i> 

                    <!-- </button> -->
                </button>
                <div class="collapse navbar-collapse" id="collapsibleNavbar">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <router-link class="nav-link" to="/mobilefamily">家谱定位表</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/mobilelineageChart">家族世系图</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/mobilescorebook">谱书</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/mobiledistributed">家族分布图表</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/mobilemigrate">家族迁徒图表</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/mobilefivefu">九族五服图</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/mobilelookfor">一键寻祖</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/mobilenews">家族动态</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/mobilecancestor">查找共祖</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/mobilestatistics">查询汇总</router-link>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="javascript:;" @click="handleCommand('logout')">退出</a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
import api from "@/request/api";
export default {
    props: ["index"],
    data() {
        return {
            activeIndex: "1",
            flag: "pc"
        };
    },
    mounted() {
        this.activeIndex = this.index;
        // if (sessionStorage.getItem("loginType")) {
        //     setInterval(function() {
        //         api.loginstatus().then((res) => {});
        //     }, 10000);
        // }

        if (this.isMobile()) {
            // 手机端
            sessionStorage.setItem("flag", "app");
            this.flag = "app";
        } else {
            // pc端
            sessionStorage.setItem("flag", "pc");
            this.flag = "pc";
        }
    },
    methods: {
          isMobile() {
            let flag = navigator.userAgent.match(
                /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
            );
            return flag;
        },
        handleSelect(key, keyPath) {},
        handleCommand(command) {
            var that = this;
            if (command == "logout") {
                api.logout().then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            message: "退出成功",
                            type: "success"
                        });
                        setTimeout(function() {
                            that.$router.push("/");
                        }, 2000);
                    }
                });
            }else if(command == 'edit'){
                that.$router.push("/material");
            }
        }
    }
};
</script>

<style lang="less" scoped>
.header {
    .header-pc {
        width: 100%;
        min-width: 1500px;
        height: 60px;
        line-height: 60px;
        background: #e04428;
        color: #fff;
        > span {
            font-size: 20px;
            vertical-align: top;
            display: inline-block;
            padding: 0 20px;
            img {
                width: 50px;
                vertical-align: middle;
            }
        }

        > img {
            vertical-align: top;
        }

        .el-menu {
            display: inline-block;
            width: 1140px;
            background: #e04428;
            border: 0;

            a {
                color: #fff;
                display: block;
                width: 100%;
                height: 100%;
                font-size: 16px;
            }
        }

        .el-menu--horizontal > .el-menu-item.is-active {
            border: 0;
            background: rgba(255, 255, 255, 0.5);
        }
        .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
        .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
            background: rgba(255, 255, 255, 0.5);
        }

        .el-dropdown {
            color: #fff;
        }
        .el-dropdown-link {
            cursor: pointer;
        }
        .el-icon-arrow-down {
            font-size: 12px;
        }
    }
    .header-app {
        .navbar-brand {
            img {
                width: 3rem;
            }
        }
        .bg-dark {
            background: #e04428 !important;
        }
        .navbar-dark .navbar-nav .nav-link {
            color: #fff;
            font-size: 16px;
        }
        .navbar-toggler{
            border:1px solid #eee !important
        }
        // .collapsed{
        //     // border: 1px solid #eee !important;
        // }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue